import { render, staticRenderFns } from "./lstClient.vue?vue&type=template&id=389d475b&scoped=true"
import script from "./lstClient.vue?vue&type=script&lang=js"
export * from "./lstClient.vue?vue&type=script&lang=js"
import style0 from "./lstClient.vue?vue&type=style&index=0&id=389d475b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389d475b",
  null
  
)

export default component.exports